
import React from "react";
import { Loader2 } from "lucide-react";
import { 
  Table, 
  TableBody, 
  TableHeader, 
  TableHead, 
  TableRow,
  TableCell 
} from "@/components/ui/table";
import { MenuItemComponent } from "./MenuItem";

interface MenuItem {
  id: string;
  title: string;
  path: string;
  icon: string;
  section: string;
  display_order: number;
  can_access: boolean;
}

interface MenuItemsTableProps {
  loading: boolean;
  menuItems: MenuItem[];
  sections: string[];
  onCheckboxChange: (id: string, checked: boolean) => void;
}

export const MenuItemsTable = ({
  loading,
  menuItems,
  sections,
  onCheckboxChange
}: MenuItemsTableProps) => {
  if (loading) {
    return (
      <div className="flex justify-center p-8">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-1/3">Menu Item</TableHead>
            <TableHead className="w-1/4">Section</TableHead>
            <TableHead className="w-1/4">Path</TableHead>
            <TableHead className="text-center">Access</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sections.map(section => (
            <React.Fragment key={section}>
              <TableRow className="bg-muted/50">
                <TableCell colSpan={4} className="font-semibold">
                  {section} Section
                </TableCell>
              </TableRow>
              {menuItems
                .filter(item => item.section === section)
                .map(item => (
                  <MenuItemComponent 
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    path={item.path}
                    section={item.section}
                    can_access={item.can_access}
                    onCheckboxChange={onCheckboxChange}
                  />
                ))
              }
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
